import owd from 'owd/owd';

export default class Submenu extends owd.Component {
	init() {
        this.$links = this.$element.find('[data-submenu-link]');

		this.colorChange();
        this.onClickChange();
        this.onScrollChange();
		this.bind();
	}


	colorChange() {
		if ((window.matchMedia('(min-width: 1356px)').matches) && $('.section--products').length) {
	        let sectionOffset = 0;
	        $('.section--products-agriculture').prevAll().each(function() {
	            sectionOffset = sectionOffset + $(this).outerHeight();
	        });
	        sectionOffset = sectionOffset - 600;

	        $(window).scroll( function() {
	            let wScroll = $(this).scrollTop();

	            if (wScroll > sectionOffset) {
	                $('.submenu').addClass('color-change');
	            } else {
	                $('.submenu').removeClass('color-change');
	            }
	        });
		}

		if ((window.matchMedia('(min-width: 1356px)').matches) && $('.section--about-numbers').length) {
	        let sectionOffset = 0;
	        $('.section--about-numbers').prevAll().each(function() {
	            sectionOffset = sectionOffset + $(this).outerHeight();
	        });
	        sectionOffset = sectionOffset - 600;

	        $(window).scroll( function() {
	            let wScroll = $(this).scrollTop();

	            if (wScroll > sectionOffset) {
	                $('.submenu').addClass('color-change');
	            } else {
	                $('.submenu').removeClass('color-change');
	            }
	        });
		}

    }

    onClickChange() {
        this.$links.on('click', function(e) {
            e.preventDefault();
            const $link = $(e.target);
            $('html, body').animate({
                scrollTop: $(this.hash).offset().top - 70
            }, 1000);
        });
    }

    onScrollChange() {
        // if ($('.section--about-group').length || $('.section--media').length || $('.section--privacy').length) {
            $(window).scroll(function(){
                let wScroll = $(this).scrollTop();
                const links = $('[data-submenu-link]');
                links.each(function() {
                    let sectionOffset = $(this.hash).offset().top - 110;
                    // console.log(sectionOffset);
                    if (sectionOffset <= wScroll) {
						$(this).parent().removeClass('submenu-item-active');
                        $(this).parent().addClass('submenu-item-active');
                        $(this).parent().siblings().removeClass('submenu-item-active');
						$(this).parent().siblings().children().removeClass('submenu-item-active')
                    }
                });
            });
        // }
    }

    bind() { }
}

owd.registerComponent('submenu', {
	component: Submenu
});
